import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createOrderNote } from "../../api/apiOrders";
import parseError from "../../utils/parseError";

export const useCreateOrderNote = () => {
    const queryClient = useQueryClient();

    const { mutate: createOrderNoteMutate, isPending: isCreatingNote } = useMutation({
        mutationFn: ({ id, data }) => createOrderNote(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Note added");
            queryClient.invalidateQueries(["order-notes"]);
            queryClient.invalidateQueries(["order-timeline"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to add note");
        },
    });

    return { createOrderNoteMutate, isCreatingNote };
};
